/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';

import { MenuItem, MenuProps } from '@mui/material';
import Menu from '@mui/material/Menu';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

export const createProfileDropdownStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    cursor: 'pointer',
    marginLeft: '14px',
  },
  avatar: {
    borderRadius: '50%',
  },
  name: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 500,
    marginLeft: 8,
    display: 'inline-block',
    verticalAlign: 'middle',
    maxWidth: '200px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  icon: {
    color: theme.palette.text.primary,
  },
  iconOpen: {
    transform: 'rotate(180deg)',
  },
  iconButton: {
    color: '#A2A7AE',
  },
}));

export const StyledMenu = withStyles({
  paper: {
    margin: '8px 0',
    border: '1px solid #EEEEEE',
    backgroundColor: '#FFFFFF',
    width: '170px',
    borderRadius: '6px',
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
})(
  memo<MenuProps>(props => (
    <Menu
      elevation={0}
      anchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  )),
);

// eslint-disable-next-line react-memo/require-memo
export const StyledMenuItem = withStyles(theme => ({
  root: {
    padding: '12px',
    position: 'relative',
    whiteSpace: 'normal',
    minHeight: '56px',
    fontSize: '14px',
    lineHeight: '18px',
    '& .MuiListItemText-primary': {
      color: theme.palette.text.primary,
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.text.primary,
      minWidth: 0,
      width: '24px',
      height: '24px',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '8px',
    },
    '&:after': {
      position: 'absolute',
      display: 'block',
      content: "''",
      bottom: 0,
      right: 0,
      left: '16px',
      height: '1px',
      backgroundColor: '#EEEEEE',
    },
    '&:last-child:after': {
      display: 'none',
    },
  },
}))(MenuItem);
